import { CircularProgress } from '@material-ui/core';
import { useStyles } from './style';

function AppLoader() {
  const classes = useStyles();

  return <CircularProgress classes={classes} />;
}

export default AppLoader;
